import api from '@/lib/api';
import { auth } from '@/lib/firebase';

export const actions = {
  async fetchSupplier() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(`/suppliers/`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchProductInsights() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(`/suppliers/insights`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchProducts(_, params) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(`/suppliers/products`,
        { 
          params,
          headers: { Authorization: `Bearer ${token}` }
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchProductFamilies() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(`/suppliers/products/family`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async addMarketplaceProduct(_, payload) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.post(`/suppliers/add/product`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async updateMarketplaceProduct(_, payload) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const id = payload.id;
      
      const data = { ...payload };
      delete data.id;

      const response = await api.put(`/suppliers/product/${id}`, data, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async updateMarketplaceProductStatus(_, payload) {
    const token = await auth.currentUser.getIdToken();
    
    try {
      const id = payload.id;
      
      const data = { ...payload };
      delete data.id;

      const response = await api.put(`/suppliers/product/${id}/status`, data, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }
      
      throw error;
    }
  },

  async fetchInsights() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(`/suppliers/product/insights`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchSupplierNames() {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(`/suppliers/names`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },

  async fetchAllProducts(_, params) {
    const token = await auth.currentUser.getIdToken();

    try {
      const response = await api.get(`/suppliers/products/all`,
        {
          params,
          headers: { Authorization: `Bearer ${token}` }
        },
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data;
      }

      throw error;
    }
  },
};

export default {
  namespaced: true,
  actions,
}